import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "emailInput", "submitButton", "message"]

  submit(event) {
    event.preventDefault()
    
    const email = this.emailInputTarget.value.trim()
    if (!email) return

    this.setLoading(true)
    this.hideMessage()

    fetch(this.formTarget.action, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ email: email })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showMessage(data.message, "success")
        this.emailInputTarget.value = ""
      } else {
        this.showMessage(data.error || "Something went wrong. Please try again.", "error")
      }
    })
    .catch(error => {
      this.showMessage("Something went wrong. Please try again.", "error")
    })
    .finally(() => {
      this.setLoading(false)
    })
  }

  setLoading(loading) {
    this.submitButtonTarget.disabled = loading
    this.submitButtonTarget.textContent = loading ? "Sending..." : "Notify Me"
  }

  showMessage(text, type) {
    this.messageTarget.textContent = text
    this.messageTarget.className = `text-sm ${type === "success" ? "text-green-600" : "text-red-600"}`
    this.messageTarget.classList.remove("hidden")
  }

  hideMessage() {
    this.messageTarget.classList.add("hidden")
  }
}
